import { useTranslation } from "react-i18next";

import { Props, PeriodOptionValue, PeriodQuickFilter } from "./interfaces";
import { PeriodType } from "../../../models/documents/period";

import { QuickFilterOption } from "../../../reusable-components/QuickFilter/interfaces";
import QuickFilter from "../../../reusable-components/QuickFilter/QuickFilter";

export const FiscalYearCompliancePeriodQuickfilter = <Q extends PeriodQuickFilter>({
  quickFilters,
  handleChangeQuickFilters,
}: Props<Q>) => {
  const { t } = useTranslation();
  const tRP = "components.quickfilters.compliance_documents_period"; // tRP - translation root path

  const { CalendaristicYear, FiscalYear, Quarter, Month } = PeriodType;

  const options: QuickFilterOption<PeriodOptionValue>[] = [
    {
      name: t(`${tRP}.any_period_type`),
      value: { periodTypes: [] },
    },
    {
      name: t(`${tRP}.years_only`),
      value: { periodTypes: [CalendaristicYear, FiscalYear] },
    },
    {
      name: t(`${tRP}.quarters_only`),
      value: { periodTypes: [Quarter] },
    },
    {
      name: t(`${tRP}.months_only`),
      value: { periodTypes: [Month] },
    },
  ];

  return (
    <QuickFilter
      options={options}
      quickFilters={quickFilters}
      quickFilter="period"
      handleChangeQuickFilter={handleChangeQuickFilters}
      shrinkedLabel={t(`${tRP}.shrinked_label`)}
    />
  );
};
